import React, {Component} from 'react';
import moment from "moment"
import ReactMarkdown from 'react-markdown'
import { StyledCard } from './style';
import { Card } from 'antd';
import { fetchRecordings } from '../../actions/coaching'
import { StyledContent } from '../../styles/mixins'

class RecordingsView extends Component {

  state = {
    coaching: {},
    isLoading: true,
  }

  async componentWillMount(){
    const coachingId = (this.props.match.params && this.props.match.params.id) || ""
    if (coachingId) {
      const coaching = await fetchRecordings(coachingId)
      if (coaching && coaching.data && coaching.data.data && coaching.data.data.coaching) {
        this.setState({
          coaching: coaching.data.data.coaching,
        })
      }
    } else {
     this.props.history.push("/coaching")
    }
    this.setState({
      isLoading: false,
    })
  }

  render() {
    const { coaching, isLoading } = this.state
    return (
      <StyledContent>
        <Card title="Recordings" bordered={false}>
          {coaching && coaching.recordingAssets && coaching.recordingAssets.length ?
            coaching.recordingAssets.map((recording, i) => (
              <div key={i} className="mb-2">
                <StyledCard title={recording.name}>
                  <div className="d-inline-block float-left">
                    <p>Start Date</p>
                    <p>{recording.recordingStart ? moment(recording.recordingStart).format("MM-DD-YYYY") : ""}</p>
                  </div>
                  <div className="d-inline-block float-right">
                    <p>End Date</p>
                    <p>{recording.recordingEnd ? moment(recording.recordingEnd).format("MM-DD-YYYY") : ""}</p>
                  </div>
                  <ReactMarkdown escapeHtml={false} source={recording.videourl}/>
                </StyledCard>
              </div>
            )) : !isLoading && <div>No Recordings Found!</div>
          }
        </Card>
      </StyledContent>
    )
  }
}
export default RecordingsView




// WEBPACK FOOTER //
// ./src/components/view-coaching/Recordings.js